export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgUmVtZWRpYXRpb25TZXR0aW5nc1N0YXR1cyA9ICJhdXRvIiB8ICJtYW51YWwiOwo="